var exports = {
  "Vg": "xe533113f--82bfcb--grid",
  "Qs": "xe533113f--82bfcb--content",
  "E1": "xe533113f--82bfcb--scrollable",
  "Sz": "xe533113f--82bfcb--show-more",
};

module.exports = exports;
